import { cva } from '@/styled-system/css';

export const upsellBannerHeaderRecipe = cva({
  base: {
    'display': {
      lg: 'inline',
    },

    'paddingInlineEnd': {
      lgDown: '1000',
    },

    '& > .c11n_heading': {
      color: 'inherit',
      textStyle: 'body-bold',
      display: {
        lg: 'inline',
      },
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'text.neutral',
      },
      soft: {
        color: 'text.neutral',
      },
      hero: {
        color: 'text.onHero.neutral',
      },
      impact: {
        color: 'text.onImpact.neutral',
      },
    },
  },
});
